(() => {
  if (window.__istemeliSearchShowcaseV7) return;
  window.__istemeliSearchShowcaseV7 = true;

  const popularSearches = [
    'Herbamina',
    'Zayıflama kahvesi',
    'Zayıflama çayı',
    'Zayıflama sirkesi',
    'Form kahvesi',
    'Bitki çayı',
    'Kayısı biberiye çayı',
    'Bromelain kahve',
    'Detoks çayı',
    'Doğal sirke'
  ];

  /*
   * Arama penceresinde yalnızca burada seçtiğimiz
   * ürünler gösterilir.
   */
  const selectedProducts = [
    {
      handle: 'inulin-ve-bromelain-coffee-90gr',
      title: 'İnülin ve Bromelain Coffee - 90 gr',
      vendor: 'HERBAMINA',
      url: '/products/inulin-ve-bromelain-coffee-90gr',
      image:
        'https://cdn.shopify.com/s/files/1/0745/3717/3161/files/1_org_zoom_f90335fe-a848-4892-94a3-cdff77666dc0.jpg?v=1787664490'
    },
    {
      handle:
        'kayisi-biberiye-karisik-bitki-cayi-apri-cot-rosemary-tea-1-5grx45-saset',
      title: 'Kayısı & Biberiye Karışık Bitki Çayı - 45 Saşe',
      vendor: 'HERBAMINA',
      url:
        '/products/kayisi-biberiye-karisik-bitki-cayi-apri-cot-rosemary-tea-1-5grx45-saset',
      image:
        'https://cdn.shopify.com/s/files/1/0745/3717/3161/files/1_org_zoom_6da14d38-41b5-4af4-9dd8-7372ff5ac160.jpg?v=1787664481'
    },
    {
      handle: 'kayisi-mix-sirke-250ml',
      title: 'Kayısı Mix Sirke 250 ml',
      vendor: 'HERBAMINA',
      url: '/products/kayisi-mix-sirke-250ml',
      image:
        'https://cdn.shopify.com/s/files/1/0745/3717/3161/files/1_org_zoom_d7bdcf89-2366-44b7-9e19-7963a1eed3f7.jpg?v=1787664479'
    },
    {
      handle:
        'form-kahvesi-7-egzotik-meyve-ve-ekstra-kafeinli-30-saset',
      title:
        'Form Kahvesi 7 Egzotik Meyve ve Ekstra Kafeinli - 30 Saşe',
      vendor: 'PATINA',
      url:
        '/products/form-kahvesi-7-egzotik-meyve-ve-ekstra-kafeinli-30-saset',
      image:
        'https://cdn.shopify.com/s/files/1/0745/3717/3161/files/1_org_zoom_4f6389b1-b7fe-4a6a-9c1f-8d378d4217a9.jpg?v=1787664681'
    }
  ];

  function searchUrl(term) {
    return `/search?q=${encodeURIComponent(
      term
    )}&options%5Bprefix%5D=last`;
  }

  function formatPrice(priceInCents) {
    const currency =
      window.Shopify?.currency?.active || 'TRY';

    const amount = Number(priceInCents) / 100;

    if (!Number.isFinite(amount)) {
      return 'Fiyatı üründe görün';
    }

    if (currency === 'TRY') {
      return `${new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount)} TL`;
    }

    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency
    }).format(amount);
  }

  /*
   * Ürün etiketlerindeki kampanya bilgilerini okur.
   *
   * Kullanılabilecek örnek etiketler:
   * kampanya:3 Al 2 Öde
   * kampanya:2. Ürün 1₺
   * sepette-indirim:10
   */
  function getCampaignData(product) {
    const tags = Array.isArray(product.tags)
      ? product.tags
      : [];

    const badges = [];
    let cartDiscountPercent = 0;

    tags.forEach((rawTag) => {
      const cleanTag = String(rawTag).trim();

      const lowercaseTag =
        cleanTag.toLocaleLowerCase('tr-TR');

      if (lowercaseTag.startsWith('kampanya:')) {
        const campaignLabel = cleanTag
          .slice(cleanTag.indexOf(':') + 1)
          .trim();

        if (
          campaignLabel &&
          badges.length < 3
        ) {
          badges.push(campaignLabel);
        }
      }

      if (
        lowercaseTag.startsWith(
          'sepette-indirim:'
        )
      ) {
        const percentage = Number(
          lowercaseTag
            .slice('sepette-indirim:'.length)
            .trim()
        );

        if (Number.isFinite(percentage)) {
          cartDiscountPercent = Math.min(
            100,
            Math.max(0, percentage)
          );
        }
      }
    });

    const selectedVariant =
      product.variants?.find(
        (variant) => variant.available
      ) ||
      product.variants?.[0] ||
      null;

    const price = Number(
      selectedVariant?.price ??
        product.price_min ??
        product.price ??
        0
    );

    const compareAtPrice = Number(
      selectedVariant?.compare_at_price ??
        product.compare_at_price_min ??
        product.compare_at_price ??
        0
    );

    let saleDiscountPercent = 0;

    if (
      compareAtPrice > price &&
      price > 0
    ) {
      saleDiscountPercent = Math.round(
        ((compareAtPrice - price) * 100) /
          compareAtPrice
      );
    }

    return {
      badges,
      price,
      cartDiscountPercent,
      saleDiscountPercent
    };
  }

  /*
   * Turuncu kampanya rozetlerini ve yeşil
   * indirim bilgisini ürün kartına yerleştirir.
   */
  function updateSearchCampaigns(card, product) {
    const campaignData =
      getCampaignData(product);

    const badgeContainer = card.querySelector(
      '[data-campaign-badges]'
    );

    if (badgeContainer) {
      badgeContainer.replaceChildren();

      campaignData.badges.forEach((label) => {
        const badge =
          document.createElement('span');

        badge.className =
          'istemeli-campaign-badge';

        badge.textContent = label;

        badgeContainer.appendChild(badge);
      });

      badgeContainer.hidden =
        campaignData.badges.length === 0;
    }

    const discountContainer =
      card.querySelector(
        '[data-campaign-discount]'
      );

    if (!discountContainer) return;

    discountContainer.replaceChildren();

    const displayedDiscount =
      campaignData.cartDiscountPercent > 0
        ? campaignData.cartDiscountPercent
        : campaignData.saleDiscountPercent;

    if (displayedDiscount <= 0) {
      discountContainer.hidden = true;
      return;
    }

    const discountLine =
      document.createElement('span');

    discountLine.className =
      'istemeli-campaign-discount-line';

    const checkIcon =
      document.createElement('span');

    checkIcon.className =
      'istemeli-campaign-check';

    checkIcon.setAttribute(
      'aria-hidden',
      'true'
    );

    checkIcon.textContent = '✓';

    const discountText =
      document.createElement('span');

    if (
      campaignData.cartDiscountPercent > 0
    ) {
      discountText.textContent =
        `Sepette %${displayedDiscount} indirim`;
    } else {
      discountText.textContent =
        `%${displayedDiscount} indirim`;
    }

    discountLine.append(
      checkIcon,
      discountText
    );

    discountContainer.appendChild(
      discountLine
    );

    /*
     * Sepette uygulanacak indirim varsa
     * hesaplanan sepette fiyatını da gösterir.
     */
    if (
      campaignData.cartDiscountPercent > 0 &&
      campaignData.price > 0
    ) {
      const cartPrice = Math.round(
        campaignData.price *
          (
            100 -
            campaignData.cartDiscountPercent
          ) /
          100
      );

      const cartPriceElement =
        document.createElement('span');

      cartPriceElement.className =
        'istemeli-campaign-cart-price';

      cartPriceElement.appendChild(
        document.createTextNode('Sepette ')
      );

      const cartPriceStrong =
        document.createElement('strong');

      cartPriceStrong.textContent =
        formatPrice(cartPrice);

      cartPriceElement.appendChild(
        cartPriceStrong
      );

      discountContainer.appendChild(
        cartPriceElement
      );
    }

    discountContainer.hidden = false;
  }

  /*
   * Seçilen ürünlerin başlık, marka, görsel,
   * fiyat, stok ve kampanya bilgilerini
   * Shopify'dan canlı olarak alır.
   */
  async function loadLiveProducts(panel) {
    const root =
      window.Shopify?.routes?.root || '/';

    const localeRoot = root.endsWith('/')
      ? root
      : `${root}/`;

    const cards = panel.querySelectorAll(
      '[data-product-handle]'
    );

    await Promise.allSettled(
      Array.from(cards).map(async (card) => {
        if (
          card.dataset.liveProductLoading ===
          'true'
        ) {
          return;
        }

        card.dataset.liveProductLoading =
          'true';

        const handle =
          card.dataset.productHandle;

        const priceElement = card.querySelector(
          '.istemeli-search-product__price'
        );

        try {
          const response = await fetch(
            `${localeRoot}products/${encodeURIComponent(
              handle
            )}.js`,
            {
              headers: {
                Accept: 'application/json'
              },
              cache: 'no-store'
            }
          );

          if (!response.ok) {
            throw new Error(
              `Ürün yüklenemedi: ${response.status}`
            );
          }

          const product =
            await response.json();

          updateSearchCampaigns(
            card,
            product
          );

          const titleElement =
            card.querySelector(
              '.istemeli-search-product__title'
            );

          const vendorElement =
            card.querySelector(
              '.istemeli-search-product__vendor'
            );

          const imageElement =
            card.querySelector(
              '.istemeli-search-product__media img'
            );

          if (
            titleElement &&
            product.title
          ) {
            titleElement.textContent =
              product.title;
          }

          if (
            vendorElement &&
            product.vendor
          ) {
            vendorElement.textContent =
              product.vendor.toUpperCase();
          }

          if (
            imageElement &&
            product.featured_image
          ) {
            imageElement.src =
              product.featured_image.startsWith(
                '//'
              )
                ? `https:${product.featured_image}`
                : product.featured_image;

            imageElement.alt =
              product.title ||
              imageElement.alt;
          }

          if (priceElement) {
            if (!product.available) {
              priceElement.textContent =
                'Tükendi';

              priceElement.classList.add(
                'is-sold-out'
              );
            } else {
              const livePrice =
                product.price_min ??
                product.price;

              const prefix =
                product.price_varies
                  ? 'Başlangıç '
                  : '';

              priceElement.textContent =
                `${prefix}${formatPrice(
                  livePrice
                )}`;

              priceElement.classList.remove(
                'is-sold-out'
              );
            }
          }
        } catch (error) {
          if (priceElement) {
            priceElement.textContent =
              'Fiyatı üründe görün';
          }

          const badgeContainer =
            card.querySelector(
              '[data-campaign-badges]'
            );

          const discountContainer =
            card.querySelector(
              '[data-campaign-discount]'
            );

          if (badgeContainer) {
            badgeContainer.hidden = true;
          }

          if (discountContainer) {
            discountContainer.hidden = true;
          }

          console.warn(
            `İstemeli canlı ürün verisi yüklenemedi: ${handle}`,
            error
          );
        } finally {
          card.dataset.liveProductLoading =
            'false';
        }
      })
    );
  }

  function createShowcase() {
    const panel =
      document.createElement('section');

    panel.className =
      'istemeli-search-showcase';

    panel.setAttribute(
      'aria-label',
      'Önerilen aramalar ve seçilen ürünler'
    );

    const chips = popularSearches
      .map(
        (term) => `
          <a
            class="istemeli-search-chip"
            href="${searchUrl(term)}"
          >
            ${term}
          </a>
        `
      )
      .join('');

    const cards = selectedProducts
      .map(
        (product) => `
          <a
            class="istemeli-search-product"
            href="${product.url}"
            data-product-handle="${product.handle}"
          >
            <span
              class="
                istemeli-campaign-badges
                istemeli-search-campaign-badges
              "
              data-campaign-badges
              hidden
            ></span>

            <span class="istemeli-search-product__media">
              <img
                src="${product.image}"
                alt="${product.title}"
                loading="lazy"
                width="220"
                height="220"
              >
            </span>

            <span class="istemeli-search-product__info">
              <span class="istemeli-search-product__vendor">
                ${product.vendor}
              </span>

              <span class="istemeli-search-product__title">
                ${product.title}
              </span>

              <span
                class="
                  istemeli-campaign-discount-wrap
                  istemeli-search-campaign-discount
                "
                data-campaign-discount
                hidden
              ></span>

              <span
                class="istemeli-search-product__price"
                aria-live="polite"
              >
                Fiyat yükleniyor...
              </span>
            </span>
          </a>
        `
      )
      .join('');

    panel.innerHTML = `
      <div class="istemeli-search-showcase__section">
        <h2 class="istemeli-search-showcase__title">
          Önerilen Aramalar
        </h2>

        <div class="istemeli-search-showcase__chips">
          ${chips}
        </div>
      </div>

      <div
        class="
          istemeli-search-showcase__section
          istemeli-search-showcase__section--products
        "
      >
        <div class="istemeli-search-showcase__heading">
          <h2 class="istemeli-search-showcase__title">
            Önerilen Ürünler
          </h2>
        </div>

        <div class="istemeli-search-showcase__products">
          ${cards}
        </div>
      </div>
    `;

    loadLiveProducts(panel);

    return panel;
  }

  /*
   * Mobilde aynı arama alanından iki adet
   * oluşmuşsa fazla olan kopyayı gizler.
   */
  function fixMobileDuplicateSearch() {
    const header = document.querySelector(
      '#header-component'
    );

    if (!header) return;

    const isMobile = window.matchMedia(
      '(max-width: 749px)'
    ).matches;

    const candidates = Array.from(
      new Set([
        ...header.querySelectorAll(
          '.istemeli-header-search'
        ),
        ...header.querySelectorAll(
          '.search-action'
        )
      ])
    );

    candidates.forEach((candidate) => {
      candidate.classList.remove(
        'istemeli-mobile-search-copy-hidden'
      );
    });

    if (!isMobile) return;

    const outerCandidates =
      candidates.filter(
        (candidate) =>
          !candidates.some(
            (other) =>
              other !== candidate &&
              other.contains(candidate)
          )
      );

    const fullWidthSearches =
      outerCandidates.filter(
        (candidate) => {
          const rect =
            candidate.getBoundingClientRect();

          return (
            rect.width >= 220 &&
            rect.height >= 34
          );
        }
      );

    if (
      fullWidthSearches.length < 2
    ) {
      return;
    }

    const primarySearch =
      fullWidthSearches.find(
        (candidate) =>
          candidate.classList.contains(
            'istemeli-header-search'
          )
      ) ||
      fullWidthSearches[0];

    fullWidthSearches.forEach(
      (candidate) => {
        if (
          candidate !== primarySearch
        ) {
          candidate.classList.add(
            'istemeli-mobile-search-copy-hidden'
          );
        }
      }
    );
  }

  function mountShowcase() {
    fixMobileDuplicateSearch();

    const modalRoot =
      document.querySelector(
        '#search-modal'
      );

    if (!modalRoot) return;

    const dialog =
      modalRoot.querySelector('dialog') ||
      modalRoot;

    const input = modalRoot.querySelector(
      'input.search-input, input[type="search"]'
    );

    const content = modalRoot.querySelector(
      '.predictive-search-form__content-wrapper, ' +
      '.predictive-search-form__content, ' +
      '[data-testid="predictive-search-content"]'
    );

    if (
      !dialog ||
      !input ||
      !content
    ) {
      return;
    }

    let panel = content.querySelector(
      ':scope > .istemeli-search-showcase'
    );

    if (!panel) {
      panel = createShowcase();
      content.prepend(panel);
    }

    function sync() {
      const isEmpty =
        input.value.trim().length === 0;

      panel.hidden = !isEmpty;

      dialog.classList.toggle(
        'istemeli-search-is-empty',
        isEmpty
      );

      Array.from(
        content.children
      ).forEach((child) => {
        if (child === panel) return;

        child.classList.toggle(
          'istemeli-default-search-hidden',
          isEmpty
        );
      });
    }

    if (
      !input.dataset
        .istemeliShowcaseV7Bound
    ) {
      input.dataset
        .istemeliShowcaseV7Bound =
        'true';

      input.addEventListener(
        'input',
        queueMount
      );

      input.addEventListener(
        'search',
        queueMount
      );
    }

    sync();
  }

  let updateQueued = false;

  function queueMount() {
    if (updateQueued) return;

    updateQueued = true;

    window.requestAnimationFrame(() => {
      updateQueued = false;
      mountShowcase();
    });
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      queueMount,
      { once: true }
    );
  } else {
    queueMount();
  }

  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target.closest(
          '.istemeli-header-search, ' +
          '[aria-controls="search-modal"]'
        )
      ) {
        window.setTimeout(
          queueMount,
          0
        );

        window.setTimeout(
          queueMount,
          80
        );
      }
    }
  );

  window.addEventListener(
    'resize',
    queueMount
  );

  new MutationObserver(
    queueMount
  ).observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
})();
/* =========================================================
   İSTEMELİ ARAMA — KESİN SON DÜZELTME V6
   ========================================================= */

(() => {
  if (window.__istemeliSearchFinalFixV6) return;
  window.__istemeliSearchFinalFixV6 = true;

  const managedHiddenNodes = new Set();
  const managedSearchCopies = new Set();

  function hideNode(node, showcase) {
    if (!node || !showcase) return;

    /*
     * Bizim öneri panelimiz veya panelin üst kapsayıcısıysa
     * paneli gizleme; diğer çocukları kontrol et.
     */
    if (node === showcase || showcase.contains(node)) {
      return;
    }

    if (node.contains(showcase)) {
      Array.from(node.children).forEach((child) => {
        if (
          child !== showcase &&
          !child.contains(showcase)
        ) {
          hideNode(child, showcase);
        }
      });

      return;
    }

    if (!node.dataset.istemeliV6Hidden) {
      const previousDisplay =
        node.style.getPropertyValue('display');

      node.dataset.istemeliV6PreviousDisplay =
        previousDisplay || '__empty__';

      node.dataset.istemeliV6Hidden = 'true';
    }

    node.style.setProperty(
      'display',
      'none',
      'important'
    );

    managedHiddenNodes.add(node);
  }

  function restoreNativeResults() {
    Array.from(managedHiddenNodes).forEach((node) => {
      if (!node?.dataset?.istemeliV6Hidden) {
        managedHiddenNodes.delete(node);
        return;
      }

      const previousDisplay =
        node.dataset.istemeliV6PreviousDisplay;

      if (
        previousDisplay &&
        previousDisplay !== '__empty__'
      ) {
        node.style.setProperty(
          'display',
          previousDisplay
        );
      } else {
        node.style.removeProperty('display');
      }

      delete node.dataset.istemeliV6PreviousDisplay;
      delete node.dataset.istemeliV6Hidden;

      managedHiddenNodes.delete(node);
    });
  }

  function restoreDialogSize(dialog, wrapper) {
    [
      'height',
      'min-height',
      'max-height',
      'margin',
      'overflow'
    ].forEach((property) => {
      dialog.style.removeProperty(property);
    });

    if (wrapper) {
      [
        'height',
        'min-height',
        'max-height',
        'overflow-x',
        'overflow-y'
      ].forEach((property) => {
        wrapper.style.removeProperty(property);
      });
    }
  }

  function fitDialogToShowcase(
    dialog,
    wrapper,
    showcase
  ) {
    window.requestAnimationFrame(() => {
      const header = dialog.querySelector(
        '.predictive-search-form__header'
      );

      const headerHeight =
        header?.getBoundingClientRect().height ||
        header?.offsetHeight ||
        66;

      const showcaseHeight = Math.max(
        showcase.scrollHeight,
        showcase.getBoundingClientRect().height
      );

      const mobile = window.matchMedia(
        '(max-width: 749px)'
      ).matches;

      const viewportSpace = mobile
        ? window.innerHeight
        : window.innerHeight - 40;

      const desiredHeight = Math.ceil(
        headerHeight + showcaseHeight + 2
      );

      const finalHeight = Math.min(
        desiredHeight,
        viewportSpace
      );

      dialog.style.setProperty(
        'height',
        `${finalHeight}px`,
        'important'
      );

      dialog.style.setProperty(
        'min-height',
        '0',
        'important'
      );

      dialog.style.setProperty(
        'max-height',
        `${viewportSpace}px`,
        'important'
      );

      dialog.style.setProperty(
        'overflow',
        'hidden',
        'important'
      );

      dialog.style.setProperty(
        'margin',
        mobile
          ? '0'
          : 'clamp(20px, 7vh, 70px) auto 0',
        'important'
      );

      wrapper.style.setProperty(
        'height',
        'auto',
        'important'
      );

      wrapper.style.setProperty(
        'min-height',
        '0',
        'important'
      );

      wrapper.style.setProperty(
        'max-height',
        `${Math.max(
          200,
          viewportSpace - headerHeight
        )}px`,
        'important'
      );

      wrapper.style.setProperty(
        'overflow-x',
        'hidden',
        'important'
      );

      wrapper.style.setProperty(
        'overflow-y',
        'auto',
        'important'
      );
    });
  }

  /*
   * Horizon mobilde normal arama ve drawer_search olmak
   * üzere iki arama kopyası oluşturabilir.
   * Biz yalnızca bir tanesini görünür bırakıyoruz.
   */
  function fixMobileSearchCopies() {
    Array.from(managedSearchCopies).forEach(
      (element) => {
        if (
          element?.dataset?.istemeliV6SearchHidden
        ) {
          const previousDisplay =
            element.dataset
              .istemeliV6SearchPreviousDisplay;

          if (
            previousDisplay &&
            previousDisplay !== '__empty__'
          ) {
            element.style.setProperty(
              'display',
              previousDisplay
            );
          } else {
            element.style.removeProperty('display');
          }

          delete element.dataset
            .istemeliV6SearchPreviousDisplay;

          delete element.dataset
            .istemeliV6SearchHidden;
        }

        managedSearchCopies.delete(element);
      }
    );

    if (
      !window.matchMedia('(max-width: 749px)').matches
    ) {
      return;
    }

    const candidates = Array.from(
      new Set([
        ...document.querySelectorAll(
          '#header-component .istemeli-header-search'
        ),
        ...document.querySelectorAll(
          '#header-component .search-action'
        ),
        ...document.querySelectorAll(
          '.istemeli-header-search'
        )
      ])
    );

    /*
     * İç içe geçmiş parçaları tek arama alanı kabul et.
     */
    const outerCandidates = candidates.filter(
      (candidate) =>
        !candidates.some(
          (other) =>
            other !== candidate &&
            other.contains(candidate)
        )
    );

    const visibleCandidates =
      outerCandidates.filter((candidate) => {
        const rect =
          candidate.getBoundingClientRect();

        return (
          rect.width >= 220 &&
          rect.height >= 34 &&
          rect.top < 600
        );
      });

    if (visibleCandidates.length <= 1) return;

    /*
     * Özel İstemeli araması varsa onu koru.
     * Yoksa Horizon'un mobil drawer aramasını koru.
     */
    const primarySearch =
      visibleCandidates.find(
        (candidate) =>
          candidate.matches(
            '.istemeli-header-search'
          ) ||
          candidate.querySelector(
            '.istemeli-header-search'
          )
      ) ||
      visibleCandidates.find(
        (candidate) =>
          candidate.matches(
            '.search-action--hidden-on-menu'
          ) ||
          candidate.querySelector(
            '.search-action--hidden-on-menu'
          )
      ) ||
      visibleCandidates[0];

    visibleCandidates.forEach((candidate) => {
      if (candidate === primarySearch) return;

      if (
        candidate.contains(primarySearch) ||
        primarySearch.contains(candidate)
      ) {
        return;
      }

      const previousDisplay =
        candidate.style.getPropertyValue('display');

      candidate.dataset
        .istemeliV6SearchPreviousDisplay =
        previousDisplay || '__empty__';

      candidate.dataset
        .istemeliV6SearchHidden = 'true';

      candidate.style.setProperty(
        'display',
        'none',
        'important'
      );

      managedSearchCopies.add(candidate);
    });
  }

  function applyFinalSearchFix() {
    fixMobileSearchCopies();

    const modal = document.querySelector(
      '#search-modal'
    );

    if (!modal) return;

    const dialog =
      modal.querySelector(
        'dialog.search-modal__content'
      ) ||
      modal.querySelector('dialog');

    const input = modal.querySelector(
      'input.search-input, input[type="search"]'
    );

    const wrapper = modal.querySelector(
      '.predictive-search-form__content-wrapper'
    );

    const showcase = modal.querySelector(
      '.istemeli-search-showcase'
    );

    if (
      !dialog ||
      !input ||
      !wrapper ||
      !showcase
    ) {
      return;
    }

    if (!input.dataset.istemeliV6Bound) {
      input.dataset.istemeliV6Bound = 'true';

      input.addEventListener(
        'input',
        queueFinalSearchFix
      );

      input.addEventListener(
        'search',
        queueFinalSearchFix
      );
    }

    const isEmpty =
      input.value.trim().length === 0;

    dialog.classList.toggle(
      'istemeli-search-is-empty',
      isEmpty
    );

    if (!isEmpty) {
      restoreNativeResults();
      restoreDialogSize(dialog, wrapper);
      return;
    }

    showcase.hidden = false;

    /*
     * Horizon'un otomatik boş arama sonuç kapsayıcısı.
     */
    const nativeContent =
      wrapper.querySelector(
        ':scope > .predictive-search-form__content'
      ) ||
      modal.querySelector(
        '.predictive-search-form__content'
      );

    const nativeFooter =
      wrapper.querySelector(
        ':scope > .predictive-search-form__footer'
      ) ||
      modal.querySelector(
        '.predictive-search-form__footer'
      );

    hideNode(nativeContent, showcase);
    hideNode(nativeFooter, showcase);

    /*
     * Tema sürümüne göre otomatik ürün alanı
     * farklı bir kapsayıcıyla oluşturulabilir.
     */
    modal
      .querySelectorAll(
        [
          '[data-testid="products-list-default--modal"]',
          '[data-testid*="products-list-default"]',
          '.predictive-search-results__inner',
          '#predictive-search-results'
        ].join(',')
      )
      .forEach((node) => {
        hideNode(node, showcase);
      });

    /*
     * Başlığı “Ürünler” olan kalan otomatik alanları
     * da kapsayıcısıyla birlikte gizle.
     */
    modal
      .querySelectorAll('h1, h2, h3, h4, h5, h6')
      .forEach((heading) => {
        if (showcase.contains(heading)) return;

        const headingText =
          heading.textContent
            .trim()
            .toLocaleLowerCase('tr-TR');

        if (headingText !== 'ürünler') return;

        const section =
          heading.closest(
            [
              '[data-testid*="products"]',
              '.predictive-search-results__group',
              '.predictive-search-results__section',
              '.predictive-search-results__inner',
              '#predictive-search-results'
            ].join(',')
          ) || heading.parentElement;

        hideNode(section, showcase);
      });

    fitDialogToShowcase(
      dialog,
      wrapper,
      showcase
    );
  }

  let finalFixQueued = false;

  function queueFinalSearchFix() {
    if (finalFixQueued) return;

    finalFixQueued = true;

    window.requestAnimationFrame(() => {
      finalFixQueued = false;
      applyFinalSearchFix();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      queueFinalSearchFix,
      { once: true }
    );
  } else {
    queueFinalSearchFix();
  }

  document.addEventListener('click', () => {
    window.setTimeout(queueFinalSearchFix, 0);
    window.setTimeout(queueFinalSearchFix, 80);
    window.setTimeout(queueFinalSearchFix, 250);
  });

  window.addEventListener(
    'resize',
    queueFinalSearchFix
  );

  new MutationObserver(
    queueFinalSearchFix
  ).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();